"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.simpleFormatCurrency = exports.isNoneAdvisoryCurrency = exports.getCurrencySymbol = exports.formatCurrency = exports.NONE_CURRENCY_VALUE = void 0;
const DEFAULT_CURRENCY_CODE = 'EUR';
const DEFAULT_LOCALE = 'es-ES';

/**
 * Returns the currency symbol for a given currency code and locale.
 *
 * @param {string} [currencyCode=DEFAULT_CURRENCY_CODE] - The currency code.
 * @param {string} [locale=DEFAULT_LOCALE] - The locale.
 * @returns {string} The currency symbol.
 */
const getCurrencySymbol = (currencyCode = DEFAULT_CURRENCY_CODE, locale = DEFAULT_LOCALE) => {
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyCode
    }).formatToParts(0).find(p => p.type === 'currency').value;
  } catch {
    // Do nothing
  }
};

/**
 * Formats the given amount as a currency string.
 *
 * @param {number|string} amount - The amount to format.
 * @param {string} [currencyCode=DEFAULT_CURRENCY_CODE] - The currency code to use for formatting.
 * @param {string} [locale=DEFAULT_LOCALE] - The locale to use for formatting.
 * @returns {string} The formatted currency string, or '-' if the amount is invalid or the conversion fails.
 */
exports.getCurrencySymbol = getCurrencySymbol;
const formatCurrency = (amount, currencyCode = DEFAULT_CURRENCY_CODE, locale = DEFAULT_LOCALE) => {
  // We need this check because other falsy invalid values would evaluate to 0 in the Intl.NumberFormat conversion below
  if (!['number', 'string'].includes(typeof amount) || amount === '') {
    return '-';
  }
  const parts = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode
  }).formatToParts(amount);
  // Check if 'nan' is present as type value. If so, conversion failed, return '-'. Otherwise reconstruct.
  if (parts.find(part => part.type === 'nan')) {
    return '-';
  }
  return parts.reduce((reconstructed, part) => reconstructed + part.value, '');
};

/**
 * Formats a given amount of currency according to the specified currency code, locale, and formatting options.
 *
 * @param {number|string} amount - The amount of currency to format.
 * @param {string} [currencyCode=DEFAULT_CURRENCY_CODE] - The currency code to use for formatting. Defaults to `DEFAULT_CURRENCY_CODE`.
 * @param {string} [locale=DEFAULT_LOCALE] - The locale to use for formatting. Defaults to `DEFAULT_LOCALE`.
 * @param {number} [minimumFractionDigits=2] - The minimum number of fraction digits to display. Defaults to `2`.
 * @param {number} [maximumFractionDigits=2] - The maximum number of fraction digits to display. Defaults to `2`.
 * @returns {string} The formatted currency string.
 */
exports.formatCurrency = formatCurrency;
const simpleFormatCurrency = (amount = 0, currencyCode = DEFAULT_CURRENCY_CODE, locale = DEFAULT_LOCALE, minimumFractionDigits = 2, maximumFractionDigits = 2) => {
  const validAmount = ['number', 'string'].includes(typeof amount) && !Number.isNaN(Number(amount)) ? amount : 0;
  const validCurrency = currencyCode ? currencyCode : DEFAULT_CURRENCY_CODE;
  const validLocale = locale ? locale : DEFAULT_LOCALE;
  return new Intl.NumberFormat(validLocale, {
    style: 'currency',
    maximumFractionDigits,
    minimumFractionDigits,
    currency: validCurrency
  }).format(validAmount);
};

/** NONE currency value */
exports.simpleFormatCurrency = simpleFormatCurrency;
const NONE_CURRENCY_VALUE = exports.NONE_CURRENCY_VALUE = 'NONE';

/**
 * Checks if the given currency is the NONE currency
 * @param {String} currency selected currency
 * @returns true if the currency is NONE
 */
const isNoneAdvisoryCurrency = currency => {
  return currency === NONE_CURRENCY_VALUE;
};
exports.isNoneAdvisoryCurrency = isNoneAdvisoryCurrency;